import { useState, useCallback } from "react";
import { useFieldActions } from "../../../contexts/field-actions-context.js";
import { useFormStatus, FORM_STATUS } from "../../../contexts/form-status-provider.js";
import { getCurrentStep } from "./utils.js";
const useSubmitButton = ({
  form,
  id
}) => {
  const { hasSteps, stepNumber, isLastStep } = getCurrentStep(form, id);
  const { inProgress, actions } = useFieldActions();
  const [submitInProgress, setSubmitInProgress] = useState(false);
  const { formStatus } = useFormStatus();
  const isDisabled = submitInProgress;
  const isInProgress = inProgress || formStatus === FORM_STATUS.BUSY;
  const showPreviousButton = hasSteps && stepNumber !== 0;
  const showNextButton = hasSteps && !isLastStep;
  const showSubmitButton = !hasSteps || hasSteps && isLastStep;
  const handleSubmitClick = useCallback(async () => {
    if (isInProgress) {
      return;
    }
    setSubmitInProgress(true);
    try {
      await actions?.submitForm();
    } catch (error) {
      console.error(error);
    }
    setSubmitInProgress(false);
  }, [actions, isInProgress]);
  return {
    handleSubmitClick,
    isDisabled,
    isInProgress,
    showPreviousButton,
    showNextButton,
    showSubmitButton,
    hasSteps
  };
};
export {
  useSubmitButton
};
//# sourceMappingURL=use-submit-button.js.map
